import React from 'react'
import { useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import ModalUi from '@mui/material/Modal'
import IconButton from '../IconButton/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { styled } from '@mui/material/styles'

import messages from './Modal.messages'

export interface IOwnProps {
  open: boolean
  onClose: () => void
  header?: () => React.ReactNode
  modalName: string
  isWideContent?: boolean
  className?: string
}

export type IProps = IOwnProps

interface ModalBodyStyledProps {
  isWideContent: boolean
}

const CloseModalButton = styled(IconButton)({
  position: 'absolute',
  top: 24,
  right: 12,
})

const ModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 35,
  left: '50%',
  transform: 'translateX(-50%)',
  maxWidth: 470,
  width: '100%',
  maxHeight: 'calc(100vh - 70px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  backgroundColor: theme.palette.whiteColor.main,
  border: `1px solid ${theme.palette.greyColor.main}`,
  borderRadius: '5px 5px 0 0',
  boxSizing: 'border-box',
}))

const ModelHeader = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.blackColor.main,
  borderRadius: '5px 5px 0 0',
  padding: '24px 50px 22px 12px',
  color: theme.palette.whiteColor.main,
  position: 'relative',
  minHeight: 72,
  boxSizing: 'border-box',
}))

const ModalBody = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'isWideContent',
})<ModalBodyStyledProps>(({ isWideContent }) => ({
  ...(!isWideContent && {
    padding: '25px 15px',
  }),
}))

const Modal: React.FC<IProps> = (props) => {
  const {
    open,
    onClose,
    header,
    children,
    modalName,
    isWideContent = false,
    className,
  } = props

  const intl = useIntl()

  return (
    <ModalUi
      open={open}
      onClose={onClose}
      aria-labelledby={`${modalName}-title`}
      aria-describedby={`${modalName}-description`}
      className={className}
    >
      <ModalBox>
        {header ? (
          <ModelHeader id={`${modalName}-title`} >
            {header()}
            <CloseModalButton
              onClick={onClose}
              icon={<CloseIcon />}
              ariaLabel={intl.formatMessage({ ...messages.closeButtonAriaLabel })}
            />

          </ModelHeader>
        ) : null}

        <ModalBody id={`${modalName}-description`} isWideContent={isWideContent}>
          {children}
        </ModalBody>
      </ModalBox>
    </ModalUi>
  )
}

export default Modal
